export default __webpack_public_path__ + "static/media/quiz.5bdf0fb9.png";